import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { environment } from '@environments/environment';
import { BreakpointService } from '@services/breakpoint.service';
import { CommonService } from '@services/common-service';
import { GoogleAnalyticsEventService } from '@services/google-analytics-events.service.service';
import { NavigationService } from '@services/navigation-service';
import { ToastService } from '@services/toastService/toastMessage.service';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { SubSink } from 'subsink';
import { manipulateEditData } from '../related-content';
import { EDIT_AIR_DATE_FILTERS, EDIT_API_FILTERS, EDIT_COLUMNS, EDIT_DEFAULT_TABLE_PARAMS, EDIT_REQUEST_STATUS_DETAILS, EDIT_STATUS_FILTERS, EDIT_TYPE_FILTERS, TableColumns } from '../related-content-utils';

type NBCApp = 'guest-tracker' | 'ncx' | 'news-search' | 'producer-dashboard';
@Component({
    selector: 'edit-related-content',
    templateUrl: './edit-related-content.component.html',
    styleUrls: ['../story-related-content.component.scss', './edit-related-content.component.scss'],
    standalone: false
})
export class EditRelatedContentComponent implements OnInit, OnDestroy, OnChanges, AfterViewChecked {

  // Story information
  @Input() storyId: number = 0;

  @Input() relatedContentHeight: number = 0;

  @Input() relatedContentTop: number = 0;

  @Input() showTempModal: boolean = false;

  @Output() totalRecords: EventEmitter<number> = new EventEmitter<number>();

  isLoaded: boolean = true;

  relatedContentData: any = [];

  headerHeight: number = 0;

  tableHeight: number = 0;

  heightToBeRemoved: number = 0;

  preferenceColumns: { [key: string]: TableColumns } = {};

  columns: any;

  private subs = new SubSink();

  airDateSortOrder: string = null;
  submittedDateSortOrder: string = null;
  apiQueryFilters: any;
  typeFilters: any;
  tableParams: any;
  statusFilters: any;
  requestStatusDetails: any;
  airDateFilters: any;

  idSearchVisible: boolean = false;
  idSearchText: string = '';

  showOrProjectSearchVisible: boolean = false;
  showOrProjectSearchText: string = '';
  priorShowOrProjectSearchText: string = '';

  requesterSearchVisible: boolean = false;
  requesterSearchText: string = '';
  priorRequesterSearchText: string = '';

  producerSearchVisible: boolean = false;
  producerSearchText: string = '';
  priorProducerSearchText: string = '';

  srProducerSearchVisible: boolean = false;
  srProducerSearchText: string = '';
  priorSrProducerSearchText: string = '';

  resetStatusButton: boolean = false;
  requestStatusVisible: boolean = false;
  requestStatusTypeFilterStatus: boolean = false;

  searchText: Subject<string> = new Subject();

  private destroy$ = new Subject();

  @ViewChild('tableHeaderSearch', { static: false }) tableHeaderSearch: ElementRef | any;


  constructor(
    private breakpointService: BreakpointService,
    private cService: CommonService,
    private toastService: ToastService,
    private gaService: GoogleAnalyticsEventService,
    private navigationService: NavigationService
  ) { }

  ngOnInit() {

    this.searchText.pipe(debounceTime(500), takeUntil(this.destroy$)).subscribe(() => {

      this.searchId();
    });

    this.typeFilters = JSON.parse(JSON.stringify(EDIT_TYPE_FILTERS));

    this.airDateFilters = JSON.parse(JSON.stringify(EDIT_AIR_DATE_FILTERS));

    this.apiQueryFilters = JSON.parse(JSON.stringify(EDIT_API_FILTERS));

    this.tableParams = JSON.parse(JSON.stringify(EDIT_DEFAULT_TABLE_PARAMS));

    this.statusFilters = JSON.parse(JSON.stringify(EDIT_STATUS_FILTERS));

    this.requestStatusDetails = JSON.parse(JSON.stringify(EDIT_REQUEST_STATUS_DETAILS));

    this.loadColumns();

    // this.totalRecords.emit(0);

    if (this.storyId) {

      this.loadRelatedContent(true);
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.storyId && changes.storyId.currentValue) {

      this.storyId = changes.storyId.currentValue;

    }

  }

  ngAfterViewChecked() {

    // this.windowResizeEvent();

  }


  /**
   * Resize event to calculate the height of the inner body to enable scroll
   **/
  public windowResizeEvent() {

    // const topHeader = (this.tableHeaderSearch?.nativeElement as HTMLElement)?.getBoundingClientRect();

    // console.log("Top Header height" + topHeader.height);

    // this.heightToBeRemoved = (32 + 16) + (16 * 3) + (24 * 2) + (40 * 2);

    // this.tableHeight = this.relatedContentHeight - this.heightToBeRemoved;

  }

  ngOnDestroy() {

    this.subs.unsubscribe();

    this.destroy$.complete();

  }

  /**
   * Make API call to get the related content for the story
   *
   */
  loadRelatedContent(emitTotalRecords: boolean = false) {

    this.isLoaded = false;

    this.apiQueryFilters.storyId = this.storyId;// 1733260492448;//1724947933414;

    let apiResponse = this.cService.serviceRequestCommon('post', environment.editRequestAPI, '', this.apiQueryFilters);

    apiResponse.subscribe((response: any) => {

      let results = response?.results || [];

      if (Array.isArray(results)) {

        manipulateEditData(response?.results);

        this.relatedContentData = [...results];

        // console.log('related Content', { relatedContent: this.data, response });

        this.tableParams.total = response.total || 0;

        if (emitTotalRecords) {
          this.totalRecords.emit(this.tableParams.total);
        }

      }

    }, (error: any) => {

      console.error('Load Related Content', error);

      this.toastService.createMessage('error', 'Error while loading related content. Please try again.');

    }).add(() => {

      this.isLoaded = true;

    });

  }

  get isMobile(): boolean {

    return this.breakpointService.isMobile.value;

  }


  /**
    * Changing pages
    * @param page {number}
    *
    */
  onChangePage(page: number) {

    this.tableParams.page = page;
    this.apiQueryFilters.start = ((page - 1) * this.apiQueryFilters.count) + 1;

    this.loadRelatedContent();

  }

  /**
   * Changing number of items to display per page
   * @param limit {number}
   *
   */
  onChangePageSize(limit: number) {

    this.tableParams.limit = limit;
    this.apiQueryFilters.count = limit;

    // If Page size changed then we need to reset page index as 1 as well start also
    const page = 1;
    this.tableParams.page = page;
    this.apiQueryFilters.start = ((page - 1) * this.apiQueryFilters.count) + 1;

    this.loadRelatedContent();
  }

  navigationTo(id: string) {

  }



  loadColumns() {

    this.preferenceColumns = {};

    this.columns = JSON.parse(JSON.stringify(EDIT_COLUMNS));;

    this.columns.forEach((column: TableColumns) => {
      this.preferenceColumns[column.value] = column;
    });

  }

  typeFilterEvent(event: any) {

    this.resetTableParams();

    if (event?.length == 0)
      this.apiQueryFilters.requestType = ['Edit Request', 'Long Form Edit Request'];
    else
      this.apiQueryFilters.requestType = event;

    this.loadRelatedContent();

  }

  statusFilterEvent(event: any) {

    this.resetTableParams();

    if (event?.length == 0)
      this.apiQueryFilters.status = ['NEW', 'REVISED', 'FULFILLED'];
    else
      this.apiQueryFilters.status = event;

    this.loadRelatedContent();

  }

  airDateFilterEvent(event: any) {

    this.resetTableParams();

    if (event?.length == 0)
      delete this.apiQueryFilters.filter.airDateTBD;
    else
      this.apiQueryFilters.filter.airDateTBD = 'Yes';

    this.loadRelatedContent();

  }

  airDateSortEvent(event: any) {

    if (event === null && this.apiQueryFilters.sortField !== 'airDate') return;
    this.resetTableParams();

    if (event == null) {
      this.apiQueryFilters.sortField = 'airDate';
      this.apiQueryFilters.sortOrder = 'descending';
    } else {
      this.apiQueryFilters.sortField = 'airDate';
      this.apiQueryFilters.sortOrder = (event == 'ascend') ? 'ascending' : 'descending';
    }

    this.airDateSortOrder = event;

    this.loadRelatedContent();
  }

  resetTableParams() {

    const currentTableParams = JSON.parse(JSON.stringify(this.tableParams));

    let defaultTableParams = JSON.parse(JSON.stringify(EDIT_DEFAULT_TABLE_PARAMS));

    defaultTableParams.limit = currentTableParams.limit;

    this.tableParams = JSON.parse(JSON.stringify(defaultTableParams));

    this.apiQueryFilters.start = 1;


  }

  /** 
   * Search for id
  */

  search() {
    this.searchText.next(this.idSearchText);
  }

  searchId(): void {
    this.resetTableParams();
    this.idSearchVisible = false;
    if (this.idSearchText.length === 0) {
      this.apiQueryFilters.filter.id = '*';
    } else {
      this.apiQueryFilters.filter.id = this.idSearchText + '*';
    }
    this.loadRelatedContent();
  }


  resetIdSearch(): void {
    this.idSearchVisible = false;
    this.idSearchText = '';
    this.apiQueryFilters.filter.id = '*';
    this.loadRelatedContent();
  }

  /** 
  * Search for a show
 */
  searchShowOrProject(): void {
    this.resetTableParams();
    this.showOrProjectSearchVisible = false;
    if (this.showOrProjectSearchText.length === 0) {
      this.apiQueryFilters.showUnit = [];
    } else {
      this.apiQueryFilters.showUnit = [this.showOrProjectSearchText + '*'];
    }
    this.priorShowOrProjectSearchText = this.showOrProjectSearchText;
    this.loadRelatedContent();
  }

  resetShowOrProjectSearch(): void {
    this.showOrProjectSearchVisible = false;
    this.showOrProjectSearchText = '';
    this.apiQueryFilters.showUnit = [];
    this.priorShowOrProjectSearchText = '';
    this.loadRelatedContent();
  }

  ShowOrProjectVisibleChange(event: boolean): void {
    if (!event && this.showOrProjectSearchText !== this.priorShowOrProjectSearchText) {
      this.searchShowOrProject();
    }
  }


  /**
   * Search for a Requester
   */
  searchRequester(): void {
    this.resetTableParams();
    this.requesterSearchVisible = false;
    if (this.requesterSearchText.length === 0) {
      this.apiQueryFilters.requester = '';
    } else {
      this.apiQueryFilters.requester = this.requesterSearchText + '*';
    }
    this.priorRequesterSearchText = this.requesterSearchText;
    this.loadRelatedContent();
  }

  resetRequesterSearch(): void {
    this.requesterSearchVisible = false;
    this.requesterSearchText = '';
    this.apiQueryFilters.requester = '';
    this.priorRequesterSearchText = '';
    this.loadRelatedContent();
  }

  requesterVisibleChange(event: boolean): void {
    if (!event && this.requesterSearchText !== this.priorRequesterSearchText) {
      this.searchRequester();
    }
  }


  /**
 * Search for a Producer
 */
  searchProducer(): void {
    this.resetTableParams();
    this.producerSearchVisible = false;
    if (this.producerSearchText.length === 0) {
      this.apiQueryFilters.filter.producerName = '';
    } else {
      this.apiQueryFilters.filter.producerName = this.producerSearchText + '*';
    }
    this.priorProducerSearchText = this.producerSearchText;
    this.loadRelatedContent();
  }

  resetProducerSearch(): void {
    this.producerSearchVisible = false;
    this.producerSearchText = '';
    this.apiQueryFilters.filter.producerName = '';
    this.priorProducerSearchText = '';
    this.loadRelatedContent();
  }

  producerVisibleChange(event: boolean): void {
    if (!event && this.producerSearchText !== this.priorProducerSearchText) {
      this.searchProducer();
    }
  }


  /**
* Search for a Senior Producer
*/
  searchSrProducer(): void {
    this.resetTableParams();
    this.srProducerSearchVisible = false;
    if (this.srProducerSearchText.length === 0) {
      this.apiQueryFilters.filter.seniorProducer = '';
    } else {
      this.apiQueryFilters.filter.seniorProducer = this.srProducerSearchText + '*';
    }
    this.priorSrProducerSearchText = this.srProducerSearchText;
    this.loadRelatedContent();
  }

  resetSrProducerSearch(): void {
    this.srProducerSearchVisible = false;
    this.srProducerSearchText = '';
    this.apiQueryFilters.filter.seniorProducer = '';
    this.priorSrProducerSearchText = '';
    this.loadRelatedContent();
  }

  srProducerVisibleChange(event: boolean): void {
    if (!event && this.srProducerSearchText !== this.priorSrProducerSearchText) {
      this.searchSrProducer();
    }
  }

  /**
  * Open selected ProdReq app for the environment
  *
  */
  openApp(url: string, key: NBCApp): boolean {

    if (this.navigationService.isIOSMobileApp.value) {
      return true;
    } else {
      const win = window.open();
      if (win) {
        win.opener = null;
        win.location.href = url;
        this.gaService.sendEvent('Story Landing - Related Content', `Open ${key}`, url, 1);
        return false;
      }
    }
  }

  windowResize() {
    this.heightToBeRemoved = (16 * 3) + (24 * 2) + (40 * 2);

    this.tableHeight = this.relatedContentHeight - this.heightToBeRemoved;

    // this.resizeColumnWidths();
  }

  closeModal() {
    this.showTempModal = false;
  }


  visibleChangeEventRequestStatus(event: any) {
    // if(!event && this.resetStatusButton)
    if (!event) {
      this.requestStatusOkEvent();
    }
  }


  /**
  * Search column filter request status
  *
  * @param listOfSearchName
  * @param selectedItem
  */
  requestStatusTypeSearch(listOfSearchName: any, selectedItem: any) {
    selectedItem.byDefault = listOfSearchName;
    this.resetStatusButton = false;
    this.resetStatusButton = this.statusFilters.some(
      (x: any) => x.byDefault === true
    );
    if (this.resetStatusButton) return;
  }

  /**
* Reset selected request Status search column filter request
*
*/
  requestStatusResetEvent() {
    this.resetTableParams();
    this.resetStatusButton = false;
    this.requestStatusVisible = false;
    this.requestStatusTypeFilterStatus = false;
    let resetStatusValue: string[] = [];

    resetStatusValue = this.statusFilters.map((val: any) => {
      val.byDefault = false;
      return val.value;
    });
    this.apiQueryFilters.status = ['NEW', 'REVISED', 'FULFILLED'];
    this.loadRelatedContent();
  }

  /**
 * Search column filter request
 *
 */
  requestStatusOkEvent() {
    this.resetTableParams();
    this.requestStatusVisible = false;
    let filterValue: any[] = [];
    this.requestStatusTypeFilterStatus = false;
    this.resetStatusButton = false;
    this.statusFilters.map((obj: any) => {
      if (obj.byDefault) {
        filterValue.push(obj.value);
        this.resetStatusButton = true;
        this.requestStatusTypeFilterStatus = true;
      }
    });
    if (filterValue && filterValue.length) {
      this.apiQueryFilters.status = filterValue;
    } else {
      this.apiQueryFilters.status = ['NEW', 'REVISED', 'FULFILLED'];
    }
    this.loadRelatedContent();
  }
}






